import { defineStore } from 'pinia'
import { AppStoreEnum } from '#lib/enums'
import type { BankListItem } from '#lib/types'
import { persistedState } from '#imports'

interface BanksState {
  banks: BankListItem[]
}

export const useUserBankStore = defineStore(AppStoreEnum.Bank, {
  state: (): BanksState => ({
    banks: [],
  }),
  persist: {
    storage: persistedState.localStorage,
  },
  actions: {
    addBank(bank: BankListItem) {
      this.banks.push(bank)
    },
    removeBank(index: number) {
      this.banks.splice(index, 1)
    },
    setBanks(banks: BankListItem[]) {
      this.banks = banks
    },
    reset() {
      this.banks = []
    },
  },
})
